module.exports = __webpack_public_path__ + "img/logo_harianjogja.39d80778.png";